export default __webpack_public_path__ + "static/media/results_per_person_a.e36a5c5d.png";